// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable jsx-a11y/anchor-is-valid */
import * as zod from "zod";

export const forgotPasswordFormSchema = zod.object({
  email: zod.string().min(1, { message: "Please enter your phone number" }),
  phoneNumber: zod
    .string()
    .min(9, { message: "Please enter your phone number" }),
});

export type ForgotPasswordFormSchemaFormValuesType = zod.infer<
  typeof forgotPasswordFormSchema
>;

export const forgotPasswordInitialValues: ForgotPasswordFormSchemaFormValuesType =
  {
    email: "",
    phoneNumber: "",
  };




  export const passwordValidation = (minLength) => zod
  .string()
  .min(minLength, `Şifreniz en az ${minLength} hane uzunluğunda olmalıdır.`)
  .refine(
    (pass) => /[A-Z]/.test(pass),
    "En az 1 büyük harf içermelidir."
  )
  .refine(
    (pass) => /[a-z]/.test(pass),
    "En az 1 küçük harf içermelidir."
  )
  .refine(
    (pass) => /\d/.test(pass),
    "En az 1 sayı içermelidir."
  )
.refine(
    (pass) => /^[a-zA-Z0-9!@$?_\-\.]*[!@$?_\-\.]+[a-zA-Z0-9!@$?_\-\.]*$/.test(pass),
    "Şifreniz sadece harf, rakam ve !@\$?_-. karakterlerini içerebilir ve en az bir !@\$?_-. karakteri bulunmalıdır."
  );
  

export const changePasswordFormSchema = (minLength) => zod
  .object({
    oldPassword: zod
      .string()
      .min(1, { message: "Please enter your old password" }),
    password: passwordValidation(minLength),
    confirmPassword: passwordValidation(minLength),
  })
  .refine((data) => data.password === data.confirmPassword, {
    message: "Passwords don't match",
    path: ["confirmPassword"],
  });

export type ChangePasswordFormSchemaFormValuesType = zod.infer<
  typeof changePasswordFormSchema
>;

export const changePasswordInitialValues: ChangePasswordFormSchemaFormValuesType = {
  oldPassword: "",
  password: "",
  confirmPassword: "",
};
// export const changePasswordFormSchema = zod
//   .object({
//     oldPassword: zod
//       .string()
//       .min(1, { message: "Please enter your phone number" }),
//     password: zod.string().min(4),
//     confirmPassword: zod.string().min(4),
//   })
//   .refine((data) => data.password === data.confirmPassword, {
//     message: "Passwords don't match",
//     path: ["confirmPassword"], // path of error
//   });

// export type ChangePasswordFormSchemaFormValuesType = zod.infer<
//   typeof changePasswordFormSchema
// >;

// export const changePasswordInitialValues: ChangePasswordFormSchemaFormValuesType =
//   {
//     oldPassword: "",
//     password: "",
//     confirmPassword: "",
//   };
